<template>
  <div>
    <div class="title">
      <span>总览</span>
    </div>

    <a-form-model
      :model="priceForm"
      :rules="rules"
      ref="priceFormRef"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <div class="proceTop">
        <a-row>
          <a-col :span="12">
            <a-form-model-item
              label="折扣(不含评审费)"
              prop="discount"
              :rules="{
                required: true,
                message: '请输入点位数',
                trigger: 'change',
              }"
            >
              <a-input
                v-model="priceForm.discount"
                @change="changePrice"
                oninput="this.value=this.value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="优惠价(含税)" prop="discountPrice">
              <!-- <a-input v-model="priceForm.discountPrice"></a-input> -->
              <span>{{ priceForm.discountPrice }} </span>
              <span v-if="priceForm.discountPrice"> (大写 : {{ form.discountPrice }})</span>
              <span></span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item
              label="总计(不含评审费)"
              prop="totalPrice"
              :rules="{
                required: true,
                message: '请填写总计(不含评审费)',
                trigger: 'change',
              }"
            >
              <!-- <a-input v-model="priceForm.totalPrice"></a-input> -->
              <span>{{ priceForm.totalPrice }}</span>
              <span v-if="priceForm.totalPrice"> (大写 : {{ form.totalPrice }})</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              label="总计(不含税)"
              prop="excludeTaxesPrice"
              :rules="{
                required: true,
                message: '请填写总计(不含税)',
                trigger: 'change',
              }"
            >
              <!-- <a-input v-model="priceForm.excludeTaxesPrice"></a-input> -->
              <span>{{ priceForm.excludeTaxesPrice }}</span>
              <span v-if="priceForm.excludeTaxesPrice"> (大写 : {{ form.excludeTaxesPrice }})</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item
              label="评 审 费"
              prop="expertEvaluation"
              :rules="{
                required: true,
                message: '请填写评审费',
                trigger: 'change',
              }"
            >
              <!-- <a-input v-model="priceForm.expertEvaluation"></a-input> -->
              <span>{{ priceForm.expertEvaluation }}</span>
              <span v-if="priceForm.expertEvaluation"> (大写 : {{ form.expertEvaluation }})</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="税   金" prop="taxes">
              <!-- <a-input v-model="priceForm.taxes"></a-input> -->
              <span>{{ priceForm.taxes }}</span>
              <span v-if="priceForm.taxes"> (大写 : {{ form.taxes }})</span>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>
      <div class="title">
        <span>联系信息</span>
      </div>
      <div>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="商务联系人"
              prop="salesman"
              :rules="{
                required: true,
                message: '请填写商务联系人',
                trigger: 'change',
              }"
            >
              <a-input v-model="priceForm.salesman" placeholder="请输入" @change="changeInformation"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="联系电话"
              prop="telephone"
              :rules="{
                required: true,
                message: '请填写联系电话',
                trigger: 'change',
              }"
            >
              <a-input v-model="priceForm.telephone" placeholder="请输入" @change="changeInformation"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="邮箱"
              prop="email"
              :rules="{
                required: true,
                message: '请填写邮箱',
                trigger: 'change',
              }"
            >
              <a-input v-model="priceForm.email" placeholder="请输入" @change="changeInformation"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="客服代表"
            >
              <span>{{ priceForm.serviceName }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="客服电话"
            >
              <span>{{ priceForm.serviceTelephone }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="客户邮箱"
            >
              <span>{{ priceForm.serviceEmail }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>
    </a-form-model>

    <div class="title">
      <span>计算规则</span>
      <span>{{ this.information }}</span>
    </div>
    <div class="proceTop">
      <p>1.税金=[总计（不含评审费）*折扣+评审费]x 0.06</p>
      <p>2.【税金】需要在十位数四舍五入取整，如102算100元的税金，105算110的税款</p>
      <p>3.优惠价=[总计（不含评审费）*折扣+评审费+税金]</p>
      <p>4.评审费不参与折扣</p>
      <p>5.不含税折扣价计算方式为：折扣价=总计（不含评审费）x折扣+评审费</p>
      <p>6.税金在折扣后计算</p>
    </div>
  </div>
</template>

<script>
import { getCustomer, items_list, itemsChildren_list, industryInfo, usreInfo } from '@/api/Industry'
import { computeLen } from '@/utils/amount'

export default {
  props: ['costList', 'informationForm', 'customerInformation', 'propRowData', 'information'],
  data() {
    return {
      priceForm: {
        discount: '',
        salesman: '',
        telephone: '',
        email: '',
        totalPrice: '',
        excludeTaxesPrice: '',
        expertEvaluation: '',
      },
      form: {
        discount: '',
        totalPrice: '',
        excludeTaxesPrice: '',
        expertEvaluation: '',
      },
      discountPrice: '',
      discountPrice1: '',
      serviceData: [],
      // customerInformation: [],
    }
  },
  mounted() {},
  watch: {
    // () {
    // }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        getCustomer().then((res) => {
          if (res.code == 200) {
            this.serviceData = res.data
            console.log(res, 'res=========================')
          }
        })
        usreInfo({
          userId: this.$store.getters.userInfo.userId,
        }).then((res) => {
          Object.assign(this.informationForm, {
            userName: res.userName,
            telephone: res.phonenumber,
            email: res.email,
          })
          this.getList()
          console.log(this.informationForm, 'this.informationForm=============================')
        })
        // this.$refs.priceRef.$refs.priceFormRef.init()
      })
    },
    changeInformation(e) {
      console.log(this.priceForm, 'eeeeeeeeeeeeeeeeeeeeeeeee')
      this.$emit('getQuoteprice', this.priceForm)
      //        Object.assign(this.priceForm, {
      //       userName:  this.informationForm.userName,
      //       telephone: this.informationForm.phonenumber,
      //       email: this.informationForm.email

      //   })
    },
    changePrice() {
      //折扣价
      this.discountPrice = this.priceForm.totalPrice * this.priceForm.discount + this.priceForm.expertEvaluation

      //税金
      var taxes = this.discountPrice * 0.06
      console.log(taxes, 'taxes================')
      this.priceForm.taxes = Math.round(taxes / 10) * 10
      this.form.taxes = computeLen(this.priceForm.taxes)

      //  this.priceForm.taxes = this.discountPrice * 0.06
      console.log(this.priceForm.taxes, 'this.priceForm.taxes ')

      //优惠价
      this.priceForm.discountPrice = this.priceForm.taxes + this.discountPrice
      this.form.discountPrice = computeLen(this.priceForm.discountPrice)

      console.log(this.priceForm.discount, 'this.priceForm.discount======')
      this.$emit('getQuoteprice', this.priceForm)
    },
    getList() {
      var num = 0
      var num1 = 0

      console.log(this.costList, 'this.costList==================')
      this.costList.forEach((item) => {
        num = num + Number(item.costList.total)
        num1 = num1 + Number(item.costList.expertEvaluation)
        Object.assign(this.priceForm, {
          discount: '',
          customerName: this.propRowData.customerName,
          serviceName: this.serviceData.name,
          serviceTelephone: this.serviceData.telephone,
          serviceEmail: this.serviceData.email,
          salesman: this.informationForm.userName,
          telephone: this.informationForm.phonenumber,
          email: this.informationForm.email,
          // salesman: this.propRowData.salesman,
          // salesmanId: this.propRowData.salesmanId,
          // telephone: this.propRowData.telephone,
          // email: this.propRowData.email,
          masterAbbreviation: this.information.abbreviation,
          masterCategory: this.information.categoryName,
          companyName: this.propRowData.companyName,
          customerId: this.propRowData.id,
        })
        console.log(this.propRowData, 'this.propRowData=============')
        console.log(this.informationForm, 'this.informationForm=============')
        console.log(this.priceForm, 'this.priceForm=============')
        console.log(this.information, 'this.information=============')
      })
      // //税金
      // this.priceForm.taxes
      // //评审费
      // expertEvaluation
      // //折扣
      // discount
      // 总计（不含税）
      // excludeTaxesPrice
      // //优惠后价格（含税）
      // discountPrice
      // //总计
      this.priceForm.excludeTaxesPrice = num
      this.form.excludeTaxesPrice = computeLen(num)

      this.priceForm.expertEvaluation = num1
      this.form.expertEvaluation = computeLen(num1)

      this.priceForm.totalPrice = num - num1
      this.form.totalPrice = computeLen(num - num1)

      console.log(num, 'num=============')
      console.log(this.priceForm.totalPrice, 'this.priceForm.totalPrice=============')
    },
  },
}
</script>

<style>
.title {
  font-size: 18px;
  padding: 5px 10px;
}
.proceTop {
  background-color: #fff;
  padding: 15px;
  border-radius: 15px;
  margin: 0 15px;
  /* padding-left: 10px; */
}
.ant-form .ant-form-horizontal {
  background-color: #fff;
}
</style>